/**
 * « Où mettre cet audio ? » — affiché à l'import ou à l'enregistrement
 * quand le projet a déjà plusieurs pistes : piste existante ou nouvelle.
 */
import type { Track } from '../state/studio';
import { TRACK_COLORS } from '../state/studio';

interface Props {
  tracks: Track[];
  title: string;
  onPick: (trackId: string | 'new') => void;
  onCancel: () => void;
}

export default function TrackPicker({ tracks, title, onPick, onCancel }: Props) {
  return (
    <div className="modal-scrim" onClick={onCancel}>
      <div className="modal" role="dialog" aria-label={title} onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <strong>{title}</strong>
          <button className="btn xs ghost" onClick={onCancel} aria-label="Annuler">✕</button>
        </div>
        <div className="picker-list">
          {tracks.map((t, i) => (
            <button key={t.id} className="picker-row" onClick={() => onPick(t.id)}>
              <span className="mx-dot" style={{ background: TRACK_COLORS[i % TRACK_COLORS.length] }} />
              <span className="export-name">{t.name}</span>
              <span className="note">{t.clips.length ? `${t.clips.length} clip${t.clips.length > 1 ? 's' : ''}` : 'vide'}</span>
            </button>
          ))}
          <button className="picker-row new" onClick={() => onPick('new')}>
            ＋ Nouvelle piste
          </button>
        </div>
      </div>
    </div>
  );
}
